const Shimmer = () => {
  return (
    <div className="flex flex-wrap">
      <div className="bg-gray-300 w-[200px] h-[400px] p-10 my-4 mx-3 rounded-xl"></div>
      <div className="bg-gray-300 w-[200px] h-[400px] p-10 my-4 mx-3 rounded-xl"></div>
      <div className="bg-gray-300 w-[200px] h-[400px] p-10 my-4 mx-3 rounded-xl"></div>
      <div className="bg-gray-300 w-[200px] h-[400px] p-10 my-4 mx-3 rounded-xl"></div>
      <div className="bg-gray-300 w-[200px] h-[400px] p-10 my-4 mx-3 rounded-xl"></div>
      <div className="bg-gray-300 w-[200px] h-[400px] p-10 my-4 mx-3 rounded-xl"></div>
      <div className="bg-gray-300 w-[200px] h-[400px] p-10 my-4 mx-3 rounded-xl"></div>
      <div className="bg-gray-300 w-[200px] h-[400px] p-10 my-4 mx-3 rounded-xl"></div>
      <div className="bg-gray-300 w-[200px] h-[400px] p-10 my-4 mx-3 rounded-xl"></div>
      <div className="bg-gray-300 w-[200px] h-[400px] p-10 my-4 mx-3 rounded-xl"></div>
      <div className="bg-gray-300 w-[200px] h-[400px] p-10 my-4 mx-3 rounded-xl"></div>
      <div className="bg-gray-300 w-[200px] h-[400px] p-10 my-4 mx-3 rounded-xl"></div>
      <div className="bg-gray-300 w-[200px] h-[400px] p-10 my-4 mx-3 rounded-xl"></div>
      <div className="bg-gray-300 w-[200px] h-[400px] p-10 my-4 mx-3 rounded-xl"></div>
      <div className="bg-gray-300 w-[200px] h-[400px] p-10 my-4 mx-3 rounded-xl"></div>
    </div>
  );
};
export default Shimmer;
